
import "C:/github-runners/esig-portal/_work/esig-client/esig-client/src/helpers/styles.less?modules";
export default {"list": `list-1XsLQVOV`,"errorContainer": `errorContainer-CDgAvkEn`,"closeIcon": `closeIcon-wrbubhUy`}
